import axios from "axios";

export const CREATE_RECEIPT = "/receipts/createReceipt";

export function createInvoiceReceipt(data: {[p: string]: unknown}) {
  return axios.post(CREATE_RECEIPT, data);
}

